<template>
  <div style="height: 80vh" class="d-flex align-items-center py-3">
    <div
      class="col-md-8 col d-flex flex-column justify-content-center align-items-center px-2 py-3"
      style="
        min-width: 400px;
        margin: auto;
        background: rgb(240 240 240 / 5%);
        box-shadow: 0px 0px 8px 1px #cacaca66;
      "
    >
      <div>
        <Onboarding ref="refOnboarding" action="registerPassword" />
        <div
          v-if="loading"
          class="d-flex justify-content-center align-items-center"
          style="min-height: 350px"
        >
          <div class="c-loader"></div>
        </div>
        <div v-else>
          <div class="text-center mb-3 mt-3">
            <h2 style="font-size: 22px" v-text="$ml.get('accessCredentials')">
              Credenciais de Acesso
            </h2>
          </div>
          <div
            v-show="invalidCredentials"
            class="alert alert-warning text-center"
          >
            <span v-text="$ml.get('warningAccessCredentials')"
              >Por favor, revise os dados fornecidos e tente novamente.</span
            >
          </div>
          <div class="form-group">
            <label class="text-muted" v-text="$ml.get('lockerPassword')"
              >Senha do cofre</label
            >
            <input
              v-model="password"
              type="password"
              class="form-control"
              placeholder="***********"
            />
            <transition name="fade">
              <label
                v-if="errorPassword"
                class="lblError"
                v-text="$ml.get('invalidPassword')"
              >
                Senha inválida
              </label>
            </transition>
          </div>
          <div class="form-group" v-if="isSMSCodeRequired">
            <label class="text-muted" v-text="$ml.get('useCodeSms')"
              >Use o código recebido por SMS</label
            >
            <the-mask
              class="form-control"
              v-model="codeSms"
              :mask="['### ###']"
              :placeholder="$ml.get('enterTheCode')"
            />
            <div
              class="col-12"
              :style="[
                { display: errorCodeEmail ? 'flex' : '' },
                { 'justify-content': errorCodeEmail ? 'space-between' : '' },
              ]"
            >
              <transition name="fade">
                <label
                  v-if="errorCodeEmail"
                  style="position: relative; !important"
                  class="lblError"
                  v-text="$ml.get('invalidCodeError')"
                >
                  O código informado não é válido!
                </label>
              </transition>
              <label
                style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                @click="sendCodeSms"
                >{{
                  timeLeftSms > 0
                    ? `${$ml.get("requestNewCodeEmail")} ${formattedTimeSMS}`
                    : $ml.get("receiveCode")
                }}</label
              >
            </div>
          </div>
          <div class="form-group" v-if="isEmailCodeRequired">
            <label class="text-muted" v-text="$ml.get('useCodeEmail')"
              >Use o código recebido por email</label
            >
            <the-mask
              class="form-control"
              v-model="codeEmail"
              :mask="['### ###']"
              :placeholder="$ml.get('enterTheCode')"
            />
            <div
              class="col-12"
              :style="[
                { display: errorCodeEmail ? 'flex' : '' },
                { 'justify-content': errorCodeEmail ? 'space-between' : '' },
              ]"
            >
              <transition name="fade">
                <label
                  v-if="errorCodeEmail"
                  style="position: relative; !important"
                  class="lblError"
                  v-text="$ml.get('invalidCodeError')"
                >
                  O código informado não é válido!
                </label>
              </transition>
              <label
                style="color: #730ba9; cursor: pointer; font-size: 12px; white-space: nowrap;"
                @click="sendCodeEmail"
                >{{
                  timeLeftEmail > 0
                    ? `${$ml.get("requestNewCodeEmail")} ${formattedTimeEmail}`
                    : $ml.get("receiveCode")
                }}</label
              >
            </div>
          </div>
          <div class="form-group" v-if="is2faCodeRequired">
            <label
              class="text-muted"
              v-text="$ml.get('useYourAuthenticationAppToEnterTheCode')"
              >Use seu aplicativo de autenticação para inserir o código</label
            >
            <the-mask
              :style="{ border: errorCode2fa ? '1px solid red' : '' }"
              class="form-control"
              v-model="code2fa"
              :mask="['### ###']"
              :placeholder="$ml.get('enterTheCode')"
            />
            <transition name="fade">
              <label
                v-if="errorCode2fa"
                class="lblError"
                v-text="$ml.get('invalidBackupCodeOrToken')"
              >
                Código ou token de backup inválidos
              </label>
            </transition>
          </div>
          <div class="d-flex justify-content-center mb-3">
            <RecaptchaV2
              ref="recaptcha"
              @verify="setRecaptchToken"
              @expired="tokenRecaptcha = ''"
            />
          </div>
          <div
            class="d-flex align-items-center justify-content-center mb-3"
            style="gap: 10px"
          >
            <button
              class="btn w-100"
              @click="loginSafe"
              :disabled="!password || !tokenRecaptcha"
              v-text="$ml.get('accessLocker')"
            >
              Acessar o cofre!
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import Onboarding from "../../components/Onboarding.vue";
import AccountService from "../../services/account.service.js";
import lockerService from "../../services/locker.service";
import store from "../../state/store";
import RecaptchaV2 from "../recaptchaV2.vue";
export default {
  name: "LockerCredentials",
  components: {
    RecaptchaV2,
    Onboarding,
  },
  props: {
    accessEnabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isEmailCodeRequired: {
      type: Boolean,
      required: true,
      default: false,
    },
    is2faCodeRequired: {
      type: Boolean,
      required: true,
      default: false,
    },
    isSMSCodeRequired: {
      type: Boolean,
      required: true,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    activePhone: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      codeSms: "",
      codeEmail: "",
      code2fa: "",
      password: "",

      errorCodeEmail: false,
      errorCode2fa: false,
      errorPassword: false,

      tokenRecaptcha: "",
      invalidCredentials: false,

      timeLeftEmail: 0,
      timeLeftSms: 0,
      formattedTimeSMS: 0,
      formattedTimeEmail: 0,
      userType: "",
    };
  },
  mounted() {
    this.$refs.modalSafe?.show();
  },
  watch: {
    code2fa() {
      this.errorCode2fa = false;
    },
    accessEnabled() {
      if (!this.accessEnabled) {
        this.$refs.modalSafe?.show();
      }
    },
  },
  methods: {
    async sendCodeEmail() {
      if (this.timeLeftEmail > 0) return;

      const newCodeRequest = 300;
      this.timeLeftEmail = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftEmail > 0) {
          this.timeLeftEmail--;

          const minutes = Math.floor(this.timeLeftEmail / 60);
          const seconds = this.timeLeftEmail % 60;

          this.formattedTimeEmail = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
        }
      }, 1000);

      try {
        const { status } = await lockerService.getTokenEmailLocker();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        if (
          error.response?.data?.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("waitToRequestNewToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }
    },
    async sendCodeSms() {
      if (!this.activePhone) {
        this.$refs.refOnboarding.startMenu();
        return;
      }
      if (this.timeLeftSms > 0) return;

      const newCodeRequest = 300;
      this.timeLeftSms = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftSms > 0) {
          this.timeLeftSms--;

          const minutes = Math.floor(this.timeLeftSms / 60);
          const seconds = this.timeLeftSms % 60;

          this.formattedTimeSMS = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
        }
      }, 1000);

      try {
        const { status } = await lockerService.getTokenSmsLocker();

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        if (
          error.response?.data?.message ===
          "Aguarde 5 minutos para receber outro token"
        ) {
          Swal.fire({
            icon: "warning",
            title: this.$ml.get("waitToRequestNewToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      }
    },
    async loginSafe() {
      this.errorCodeEmail = false;
      this.errorCode2fa = false;
      this.errorPassword = false;
      this.invalidCredentials = false;

      try {
        let payload = {
          password: this.password,
          tokenRecaptcha: this.tokenRecaptcha,
        };

        // if (this.$store.getters["getUserType"] === "hacker") {
        //   payload.lockerEmailToken = Number(this.codeEmail);
        // }
        if (this.isEmailCodeRequired) {
          payload.lockerEmailToken = Number(this.codeEmail);
        }
        if (this.is2faCodeRequired) {
          payload.lockerAppToken = this.code2fa;
        }
        if (this.isSMSCodeRequired) {
          payload.lockerSmsToken = Number(this.codeSms);
        }

        const { data, status } = await AccountService.postLoginSafe(payload);

        localStorage.setItem("token_safe", data);
        store.dispatch("setTokenSafe", data);

        const decodedStr = JSON.parse(atob(data.split(".")[1]));

        const safeTimeInactive = new Date(decodedStr.exp * 1000);

        store.dispatch("setSafeTimeInactive", safeTimeInactive);

        if (status === 201) {
          this.$emit("accessSafe");
          this.$refs.modalSafe.hide();
        }
        this.codeSms = "";
        this.codeEmail = "";
        this.code2fa = "";
      } catch (error) {
        this.$refs.recaptcha.resetRecaptcha();
        this.tokenRecaptcha = "";

        if (
          error.response.data.message ===
          "As credenciais do cofre não são válidas!"
        ) {
          this.invalidCredentials = true;
          return;
        }
        if (
          error.response.data.message ===
          "As credenciais do cofre não são válidas."
        ) {
          this.invalidCredentials = true;
          return;
        }
        if (
          error.response.data.message[0] ===
          "O app_token informado não é válido!"
        ) {
          this.errorCode2fa = true;
          return;
        }
      }
    },
    setRecaptchToken(token) {
      this.tokenRecaptcha = token;
    },

    openModal() {
      this.$refs.modalSafe?.show();
    },
  },
};
</script>
